import { gql } from "@apollo/client"
import { useQuery, UseQueryOptions } from "@oysterhr/core"
import { Company, PaymentsSettings, QueryCompanyArgs } from "@oysterhr/schema"

const QUERY = gql`
  query InvoicingCompanyClientsSelectClients($companyId: ID!) {
    company(companyId: $companyId) {
      id
      isClient
      isCustomer
      clients {
        id
        name
        avatarUrl
      }
      paymentsSettings {
        restricted
      }
    }
  }
`

type QueryResponse = {
  company: Pick<Company, "id" | "isClient" | "isCustomer"> & {
    clients: Pick<Company, "id" | "name" | "avatarUrl">[]
    paymentsSettings: Pick<PaymentsSettings, "restricted">
  }
}

export const useCustomerClientsQuery = (
  options: UseQueryOptions<QueryResponse, QueryCompanyArgs>,
) => useQuery<QueryResponse, QueryCompanyArgs>(QUERY, options)
